const CHANGE_PASSWORD_EVENTS = {
  CHANGE_PASSWORD_SUCCESS: 'CHANGE_PASSWORD_SUCCESS',
  CHANGE_PASSWORD_FAILURE: 'CHANGE_PASSWORD_FAILURE',
}

export default CHANGE_PASSWORD_EVENTS
